/**
 * @voltxampere/ui — Ground (Toprak)
 *
 * Three descending bars under a vertical stub. Canonical zenit-brand
 * draws the top bar at stroke-width 1.8 and the bottom whisker at
 * 1.2; the Zenit §9.1 spec mandates the 1.3-1.6 range. Both are
 * clamped here (heavy → 1.6, whisker → 1.3 detail) so the symbol
 * stays inside the brand-discipline gate without changing geometry.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { STROKE_IVORY, STROKE_WIDTH_DETAIL, STROKE_WIDTH_HEAVY, STROKE_WIDTH_MAIN, VIEWBOX_DEFAULT, } from "./constants.js";
export const ground = {
    id: "ground",
    nameTr: "Toprak",
    nameEn: "Ground",
    shortcut: "G",
    category: "connector",
    viewBox: VIEWBOX_DEFAULT,
    terminals: [{ x: 20, y: 4, polarity: "bi" }],
    renderSVG: () => [
        `<line x1="20" y1="4" x2="20" y2="14" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="10" y1="14" x2="30" y2="14" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_HEAVY)}"/>`,
        `<line x1="14" y1="18" x2="26" y2="18" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="17" y1="22" x2="23" y2="22" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_DETAIL)}"/>`,
    ].join(""),
};
//# sourceMappingURL=ground.js.map